/* Shared cart Preview / Save my design. One instance across cart page and drawer. */
(function () {
  'use strict';
  if (window.SoulyshineCartUI) return;
  var initialized = false;
  var activeOverlay = null;
  var overlayContext = null;
  var swallowEscapeKeyup = false;


  document.addEventListener('cart:updated', function(event) {
    if (!event.detail || event.detail.renderer !== 'soulyshine-drawer') return;
    // Use the shared Liquid count from the freshly rendered cart sections.
    var heading = document.querySelector('cart-drawer [data-ss-main-item-count]');
    if (!heading) return;
    var count = Number(heading.dataset.ssMainItemCount);
    var counterEl = document.querySelector('#cart-item-count');
    if (counterEl && Number.isSafeInteger(count) && count >= 0) counterEl.textContent = count;
  });

  function inkInitCart() {
    if (initialized) return;
    var modal = document.getElementById('ink-send-modal');
    var lightbox = document.getElementById('ink-preview-lightbox');
    var form = document.getElementById('ink-send-form');
    var successBox = document.getElementById('ink-send-success');

    if (!modal || !form || !lightbox) {
      return;
    }

    initialized = true;

    var currentDesignUrl = '';
    var currentProductUrl = '';
    var currentProductTitle = '';
    var currentPreviewUrl = '';
    var currentProductPrice = 0;

    document.addEventListener('click', function(e) {
      // ===== Show details toggle =====
      var toggleBtn = e.target.closest('.ink-toggle-details');
      if (toggleBtn) {
        var target = document.getElementById(toggleBtn.dataset.target);
        if (!target) return;
        var isHidden = target.hasAttribute('hidden');
        var label = toggleBtn.querySelector('.ink-toggle-label');
        if (isHidden) {
          target.removeAttribute('hidden');
          toggleBtn.setAttribute('aria-expanded', 'true');
          if (label) label.textContent = 'Hide details';
        } else {
          target.setAttribute('hidden', '');
          toggleBtn.setAttribute('aria-expanded', 'false');
          if (label) label.textContent = 'Show details';
        }
        return;
      }

      // ===== Preview lightbox =====
      var previewBtn = e.target.closest('.ink-preview-btn');
      if (previewBtn) {
        var imgUrl = previewBtn.dataset.image;
        var caption = previewBtn.dataset.productTitle || '';
        if (imgUrl) {
          var lbImg = document.getElementById('ink-lb-img');
          var lbCap = document.getElementById('ink-lb-caption');
          if (lbImg) lbImg.src = imgUrl;
          if (lbCap) lbCap.textContent = caption;
          openOverlay(lightbox, previewBtn, lightbox.querySelector('[data-close-lb]'));
        }
        return;
      }

      // ===== Save modal open =====
      var sendBtn = e.target.closest('.ink-btn-send-design');
      if (sendBtn) {
        currentDesignUrl = sendBtn.dataset.customilyUrl || '';
        currentProductUrl = sendBtn.dataset.productUrl || '';
        currentProductTitle = sendBtn.dataset.productTitle || '';
        currentPreviewUrl = sendBtn.dataset.previewUrl || '';
        currentProductPrice = parseFloat(sendBtn.dataset.productPrice) || 0;
        var fallbackImg = sendBtn.dataset.fallbackImg || '';

        var img = document.getElementById('ink-modal-preview-img');
        if (img) img.src = currentPreviewUrl || fallbackImg;

        var titleEl = document.getElementById('ink-modal-product-title');
        if (titleEl) titleEl.textContent = currentProductTitle;

        form.hidden = false;
        successBox.hidden = true;
        form.reset();
        openOverlay(modal, sendBtn, document.getElementById('ink-modal-email'));
        return;
      }
    });

    // ===== Personalization link logic =====
    // The Customily customization URL points to the product page with the
    // saved design pre-loaded. Customers can return to this link to edit
    // their design or finish their purchase.
    function getPersonalizationLink() {
      if (currentDesignUrl && typeof currentDesignUrl === 'string' && currentDesignUrl.length > 0) {
        return currentDesignUrl;
      }
      if (currentProductUrl && typeof currentProductUrl === 'string' && currentProductUrl.length > 0) {
        return currentProductUrl;
      }
      return window.location.origin || 'https://soulyshine.com';
    }

    function showShareToast(msg) {
      var t = document.getElementById('ink-share-toast');
      if (!t) return;
      t.textContent = msg;
      t.hidden = false;
      clearTimeout(t._hideTimer);
      t._hideTimer = setTimeout(function() { t.hidden = true; }, 2200);
    }

    function copyToClipboard(text) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        return navigator.clipboard.writeText(text).catch(function() { fallbackCopy(text); });
      } else {
        fallbackCopy(text);
      }
    }
    function fallbackCopy(text) {
      try {
        var ta = document.createElement('textarea');
        ta.value = text;
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        (activeOverlay || document.body).appendChild(ta);
        ta.select();
        document.execCommand('copy');
        ta.parentNode.removeChild(ta);
      } catch (e) { /* noop */ }
    }

    // ===== Copy personalization link button =====
    var copyLinkBtn = document.getElementById('ink-copy-personalization-link');
    if (copyLinkBtn) {
      copyLinkBtn.addEventListener('click', function() {
        var link = getPersonalizationLink();
        copyToClipboard(link);
        showShareToast('Personalization link copied!');

        // Visual confirmation on the button itself
        var labelEl = copyLinkBtn.querySelector('.ink-btn-copy-link__label');
        if (labelEl) {
          var original = labelEl.textContent;
          labelEl.textContent = '✓ Copied!';
          copyLinkBtn.classList.add('is-copied');
          setTimeout(function() {
            labelEl.textContent = original;
            copyLinkBtn.classList.remove('is-copied');
          }, 2000);
        }

        // Track copy intent
        try {
          if (window.fbq) {
            fbq('trackCustom', 'DesignLinkCopied', { value: currentProductPrice || 0, currency: 'USD' });
          }
          if (window.klaviyo && window.klaviyo.track) {
            window.klaviyo.track('Design Link Copied', {
              product_title: currentProductTitle,
              design_url: currentDesignUrl,
              preview_url: currentPreviewUrl
            });
          } else if (window._learnq) {
            window._learnq.push(['track', 'Design Link Copied', {
              product_title: currentProductTitle,
              design_url: currentDesignUrl,
              preview_url: currentPreviewUrl
            }]);
          }
        } catch (err) { /* tracking failures must not break copy */ }
      });
    }

    // ===== Close handlers — click backdrop OR explicit close button =====
    function closeModal() {
      closeOverlay(modal);
    }
    function closeLightbox() {
      closeOverlay(lightbox);
    }


    // Modal: click on backdrop (e.target === modal itself) or on × button
    modal.addEventListener('click', function(e) {
      if (e.target === modal) { closeModal(); return; }
      if (e.target.closest('[data-close-modal]')) { closeModal(); }
    });

    // Lightbox: click on backdrop (e.target === lightbox itself) or on × button
    lightbox.addEventListener('click', function(e) {
      if (e.target === lightbox) { closeLightbox(); return; }
      if (e.target.closest('[data-close-lb]')) { closeLightbox(); }
    });

    // Handle both phases of Escape before Shrine sees the restored drawer trigger.
    document.addEventListener('keydown', function(e) {
      if (e.key !== 'Escape' || !activeOverlay) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      swallowEscapeKeyup = true;
      closeOverlay(activeOverlay);
    }, true);
    document.addEventListener('keyup', function(e) {
      if (e.key !== 'Escape' || !swallowEscapeKeyup) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      swallowEscapeKeyup = false;
    }, true);

    // ===== Save my design (self via email/SMS) =====
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var submitBtn = form.querySelector('.ink-btn-primary');
      var emailEl = document.getElementById('ink-modal-email');
      var emailVal = (emailEl && emailEl.value || '').trim();

      if (!emailVal) {
        emailEl.focus();
        emailEl.style.borderColor = '#EB001B';
        return;
      }
      emailEl.style.borderColor = '';

      submitBtn.disabled = true;
      submitBtn.textContent = 'Sending...';

      var phoneVal = document.getElementById('ink-modal-phone').value;
      var optinVal = document.getElementById('ink-modal-marketing').checked;

      trackDesignSaved({
        email: emailVal,
        phone: phoneVal,
        marketing_optin: optinVal,
        design_url: currentDesignUrl,
        product_title: currentProductTitle,
        preview_url: currentPreviewUrl,
        product_price: currentProductPrice
      })
      .then(function() {
        form.hidden = true;
        successBox.hidden = false;
        if (window.fbq) {
          fbq('trackCustom', 'DesignSaved', { value: currentProductPrice || 0, currency: 'USD' });
        }
      })
      .catch(function(err) {
        console.error('[Save Design] Error:', err);
        alert('Could not send. Please try again.');
      })
      .then(function() {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Send me the link';
      });
    });


    // ===== Preview-label cleanup =====
    // Customily app injects bare "Preview" text labels at runtime near addon
    // line items. We hide them aggressively with multiple CSS overrides via the
    // `.ink-force-hidden` class — harder for Customily's reactive system to undo
    // than a single `display:none` style.
    //
    // FLICKER FIX: this must run SYNCHRONOUSLY on every DOM mutation (no debounce).
    // The 200ms debounce previously used was the flicker window — Customily would
    // inject, user would see, then JS would hide. Now we hide before paint.
    function isPreviewTextNode(el) {
      if (!el || !el.classList) return false;
      if (el.classList.contains('ink-force-hidden')) return false;        // already hidden
      if (el.classList.contains('ink-preview-btn')) return false;          // our button
      if (el.closest && el.closest('.ink-preview-btn')) return false;      // inside our button
      if (el.closest && el.closest('.ink-modal-eyebrow')) return false;    // modal label "Your design"
      if (el.closest && el.closest('.ink-modal-h3')) return false;         // modal title
      if (el.closest && el.closest('.ink-share-toast')) return false;      // toast
      if (el.children && el.children.length > 0) return false;             // not a leaf
      var txt = (el.textContent || '').trim().toLowerCase();
      return txt === 'preview';
    }

    function hideEl(el) {
      el.classList.add('ink-force-hidden');
      // Belt-and-braces: also set inline style so even if class is stripped, style holds
      try {
        el.setAttribute('aria-hidden', 'true');
      } catch (e) {}
    }

    function cleanupPreviewLabels() {
      var rows = document.querySelectorAll('.ink-cart-row, .ss-drawer-item');
      rows.forEach(function(row) {
        var nodes = row.querySelectorAll('div, span, p, a, label');
        nodes.forEach(function(el) {
          if (isPreviewTextNode(el)) hideEl(el);
        });
      });
    }

    // Process specific newly-added subtrees only (perf optimization for MO callback)
    function processAddedSubtree(node) {
      if (node.nodeType !== 1) return;
      if (!node.closest('.ink-cart-row, .ss-drawer-item')) {
        node.querySelectorAll('.ink-cart-row, .ss-drawer-item').forEach(processAddedSubtree);
        return;
      }
      if (isPreviewTextNode(node)) hideEl(node);
      if (node.querySelectorAll) {
        var descendants = node.querySelectorAll('div, span, p, a, label');
        for (var i = 0; i < descendants.length; i++) {
          if (isPreviewTextNode(descendants[i])) hideEl(descendants[i]);
        }
      }
    }

    // Initial sweep + delayed sweeps to catch async-rendered Customily UI
    cleanupPreviewLabels();
    setTimeout(cleanupPreviewLabels, 0);
    setTimeout(cleanupPreviewLabels, 100);
    setTimeout(cleanupPreviewLabels, 500);
    setTimeout(cleanupPreviewLabels, 1500);
    setTimeout(cleanupPreviewLabels, 3000);
    document.addEventListener('cart:updated', cleanupPreviewLabels);

    // SYNCHRONOUS MutationObserver — no debounce. Fires before browser paint,
    // so user never sees the "Preview" text flash visible before we hide it.
    // We observe childList only (not attributes), so adding our `.ink-force-hidden`
    // class doesn't re-trigger the observer.
    var cartContainer = document.body;
    if (cartContainer && typeof MutationObserver !== 'undefined') {
      var mo = new MutationObserver(function(mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var added = mutations[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            processAddedSubtree(added[j]);
          }
        }
      });
      mo.observe(cartContainer, { childList: true, subtree: true });
    }

    // ===== Protection Plan cap: max 1 per order =====
    // Run ONCE on initial page load only. Do NOT hook cart:updated — that
    // event fires when ANY cart change happens (including our own reload-induced
    // cart fetches, Customily background syncs, AJAX cart drawer updates),
    // which can cause a fetch→update→reload loop that ends with empty cart
    // if Customily session has expired in the meantime.
    function inkEnforceProtectionPlanCap() {
      return fetch('/cart.js', { credentials: 'same-origin' })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var ppItems = (cart.items || []).filter(function(it) {
            var h = it.handle || it.product_handle || '';
            return h === 'the-2-year-jewelry-protection-plan';
          });
          if (ppItems.length === 0) return;

          var totalQty = ppItems.reduce(function(sum, it) { return sum + (it.quantity || 0); }, 0);
          if (totalQty <= 1) return;

          var updates = {};
          ppItems.forEach(function(it, idx) {
            updates[it.key] = (idx === 0) ? 1 : 0;
          });
          console.log('[Cart] Capping Protection Plan: total qty', totalQty, '→ 1');

          return fetch('/cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({ updates: updates })
          }).then(function() {
            window.location.reload();
          });
        })
        .catch(function(err) {
          console.warn('[Cart] Protection Plan cap check failed:', err);
        });
    }

    // ONE-SHOT only on initial page load. The max="1" attribute on the input
    // already prevents user from increasing past 1 in this view, so we don't
    // need to keep policing.
    if (!document.querySelector('cart-drawer') && document.querySelector('.ink-cart-list')) {
      inkEnforceProtectionPlanCap();
    }
    window.SoulyshineCartUI.refresh = function () {
      cleanupPreviewLabels();
      syncOverlayDrawer();
    };
  }

  function trackDesignSaved(payload) {
    return new Promise(function(resolve, reject) {
      var eventProps = {
        design_url: payload.design_url,
        product_title: payload.product_title,
        preview_url: payload.preview_url,
        product_price: payload.product_price,
        marketing_optin: payload.marketing_optin,
        saved_at: new Date().toISOString()
      };

      var customerProps = {
        $email: payload.email,
        $consent: payload.marketing_optin ? ['email'] : []
      };
      if (payload.phone) customerProps.$phone_number = payload.phone;

      if (typeof window.klaviyo !== 'undefined' && window.klaviyo.identify) {
        window.klaviyo.identify(customerProps)
          .then(function() { return window.klaviyo.track('Design Saved', eventProps); })
          .then(function() { resolve(true); })
          .catch(reject);
        return;
      }

      if (typeof window._learnq !== 'undefined') {
        try {
          window._learnq.push(['identify', customerProps]);
          window._learnq.push(['track', 'Design Saved', eventProps]);
          setTimeout(resolve, 500);
        } catch (err) {
          reject(err);
        }
        return;
      }

      reject(new Error('Klaviyo not available on page'));
    });
  }

  function openOverlay(overlay, trigger, firstFocus) {
    if (activeOverlay && activeOverlay !== overlay) closeOverlay(activeOverlay);
    if (!activeOverlay) {
      var drawer = trigger && trigger.closest('cart-drawer');
      var drawerDialog = drawer && drawer.querySelector('[role="dialog"]');
      overlayContext = {
        trigger: trigger,
        drawer: drawer,
        drawerDialog: drawerDialog,
        drawerAriaHidden: drawerDialog && drawerDialog.getAttribute('aria-hidden'),
        overflow: document.body.style.overflow
      };
    }
    activeOverlay = overlay;
    overlay.hidden = false;
    document.body.style.overflow = 'hidden';
    if (typeof window.removeTrapFocus === 'function') window.removeTrapFocus();
    if (typeof window.trapFocus === 'function') window.trapFocus(overlay, firstFocus);
    else if (firstFocus) firstFocus.focus();
    if (overlayContext && overlayContext.drawerDialog) overlayContext.drawerDialog.setAttribute('aria-hidden', 'true');
    document.dispatchEvent(new CustomEvent('soulyshine:cart-overlay-open', {detail: {overlay: overlay}}));
  }

  function restoreDrawerAria(context) {
    if (!context || !context.drawerDialog) return;
    if (context.drawerAriaHidden === null) context.drawerDialog.removeAttribute('aria-hidden');
    else context.drawerDialog.setAttribute('aria-hidden', context.drawerAriaHidden);
  }

  function syncOverlayDrawer() {
    if (!activeOverlay || !overlayContext) return;
    var drawer = overlayContext.drawer;
    if (!drawer || !drawer.isConnected) return;
    var dialog = drawer.querySelector('[role="dialog"]');
    if (dialog !== overlayContext.drawerDialog) {
      // Section rendering replaces the underlying dialog while the overlay
      // remains open. Preserve each node's original state exactly once.
      restoreDrawerAria(overlayContext);
      overlayContext.drawerDialog = dialog;
      overlayContext.drawerAriaHidden = dialog && dialog.getAttribute('aria-hidden');
    }
    if (dialog) dialog.setAttribute('aria-hidden', 'true');
  }

  function closeOverlay(overlay) {
    if (!overlay || overlay.hidden) return;
    if (activeOverlay === overlay) syncOverlayDrawer();
    overlay.hidden = true;
    if (activeOverlay !== overlay) return;
    var context = overlayContext;
    activeOverlay = null;
    overlayContext = null;
    if (typeof window.removeTrapFocus === 'function') window.removeTrapFocus();
    if (context) {
      document.body.style.overflow = context.overflow;
      restoreDrawerAria(context);
      var trigger = context.trigger && context.trigger.isConnected ? context.trigger : null;
      var drawer = context.drawer;
      if (drawer && drawer.isConnected && drawer.classList.contains('active')) {
        var dialog = drawer.querySelector('[role="dialog"]') || drawer;
        trigger = trigger || drawer.querySelector('.drawer__close');
        if (typeof window.trapFocus === 'function') window.trapFocus(dialog, trigger || dialog);
        else if (trigger) trigger.focus();
      } else if (trigger) trigger.focus();
    }
    document.dispatchEvent(new CustomEvent('soulyshine:cart-overlay-close'));
  }

  window.SoulyshineCartUI = {
    init: inkInitCart,
    refresh: function() {},
    isOverlayOpen: function() { return !!activeOverlay; }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inkInitCart);
  } else {
    inkInitCart();
  }

})();
